export default __webpack_public_path__ + "static/NET-AI-PDF-6a0507441f732a8b30f6a28dd3ae01c9.jpg";